import { Header } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { Avatar, Dropdown, Menu, MenuProps, Badge, Button } from "antd";
import { ShoppingOutlined } from "@ant-design/icons";
import { AuthContext } from "../../../config/AuthContext";
import { CheckOutlined, HomeMax, LogoutOutlined, Person } from "@mui/icons-material";
import { BsBackpack, BsDatabase, BsPerson, BsChatDots, BsBook, BsBell, BsLightbulb, BsCodeSquare } from "react-icons/bs";
import { RiJavascriptFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import MetadataColors from "../../../styles/MetadataColors";
import GlobalChatNotification from "../../components/GlobalChatNotification";
import ChatTableModal from "../../jutge/components/ChatTableModal";
import SugerimentsModal from "../../components/SugerimentsModal";
import AdminSugerimentsModal from "../../components/AdminSugerimentsModal";
import { CountUnreadSugeriments } from "../../../dao/jutge/CountUnreadSugeriments";
import UseWebSocketSubscription from "../../UseWebSocketSubscription";
import UserProfileMenu from "../../components/UserProfileMenu";

const AppHeader = () => {
    const { isLoggedIn, userPermisos, alumne, user } = useContext(AuthContext);
    const titles: string[] = ["Home", "Base de Dades", "Jutge Online", "Projectes", "Metadata"];
    const paths: string[] = ["/home", "/database", "/jutge", "/abp", "/metadata"];
    const icons: any[] = [HomeMax, BsDatabase, RiJavascriptFill, CheckOutlined, BsCodeSquare];

    const navigate = useNavigate();
    const [historyVisible, setHistoryVisible] = useState(false);
    const [sugerimentsVisible, setSugerimentsVisible] = useState(false);
    const [adminSugerimentsVisible, setAdminSugerimentsVisible] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    const isAdmin = user?.tipus === "1" || user?.tipus === "0";
    const isImpersonating = !!localStorage.getItem('adminToken');

    const handleStopImpersonation = () => {
        const adminToken = localStorage.getItem('adminToken');
        if (adminToken) {
            localStorage.setItem('authToken', adminToken);
            localStorage.setItem('userId', localStorage.getItem('admin_userId') || '');
            localStorage.setItem('user', localStorage.getItem('admin_user') || '');
            localStorage.setItem('userPermisos', localStorage.getItem('admin_userPermisos') || '');
            localStorage.setItem('alumneInfo', localStorage.getItem('admin_alumneInfo') || '');

            localStorage.removeItem('adminToken');
            localStorage.removeItem('admin_userId');
            localStorage.removeItem('admin_user');
            localStorage.removeItem('admin_userPermisos');
            localStorage.removeItem('admin_alumneInfo');

            window.location.reload();
        }
    };

    useEffect(() => {
        if (isAdmin) fetchCount();
    }, [isAdmin]);

    const fetchCount = useCallback(async () => {
        const c = await CountUnreadSugeriments();
        setUnreadCount(c);
    }, []);

    const onWebSocketMessage = useCallback(() => {
        if (isAdmin) fetchCount();
    }, [isAdmin, fetchCount]);

    UseWebSocketSubscription(['/topic/sugerencias'], onWebSocketMessage);

    type MenuItem = Required<MenuProps>["items"][number];

    const nomAlumne = alumne?.alumne?.nom || "usuari";

    const hasJutgePermission = userPermisos.some((valor: any) => valor.accio === '/jutge');


    const items1: MenuItem[] = icons
        .map((icon, index) => {
            const key = String(index + 1);
            const hasPermission = userPermisos.some((valor: any) => valor.accio === paths[index]);
            if (!hasPermission) return null;

            return {
                key,
                icon: React.createElement(icon),
                label: titles[index],
                onClick: () => navigate(paths[index]),
                style: {
                    color: paths[index] === '/metadata' ? MetadataColors.colors.color3 : 'inherit',
                    fontWeight: paths[index] === '/metadata' ? 'bold' : 'normal',
                }
            };
        })
        .filter(Boolean);


    const onClick: MenuProps["onClick"] = (e) => {
        const pathIndex = parseInt(e.key) - 1;
        // console.log(pathIndex);
    };

    if (!isLoggedIn) return null;

    return (
        <Header
            style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: MetadataColors.colors.color6, position: 'sticky', top: 0, zIndex: 1000, width: '100%',
            }}
        >
            <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                <Menu
                    theme={"light"}
                    onClick={onClick}
                    mode="horizontal"
                    items={items1}
                    defaultSelectedKeys={["5"]}
                    style={{
                        flex: 1,
                        minWidth: 0,
                        backgroundColor: MetadataColors.colors.color6,
                        borderBottom: 'none'
                    }}
                />
            </div>

            <GlobalChatNotification />

            {isAdmin && (
                <div style={{ marginRight: 24, cursor: 'pointer' }} onClick={() => setAdminSugerimentsVisible(true)}>
                    <Badge count={unreadCount} overflowCount={99}>
                        <BsBell style={{ color: "white", fontSize: 20 }} />
                    </Badge>
                </div>
            )}

            {isImpersonating && (
                <Button
                    type="primary"
                    danger
                    onClick={handleStopImpersonation}
                    style={{ marginRight: 16 }}
                >
                    Volver a Admin
                </Button>
            )}

            {/* Icono de perfil a la derecha */}
                {/* Icono de perfil centralizado */}
                <UserProfileMenu />
            <ChatTableModal
                visible={historyVisible}
                onClose={() => setHistoryVisible(false)}
                isHistory={true}
                aula={{ id: 0 }}
            />
            <SugerimentsModal visible={sugerimentsVisible} onClose={() => setSugerimentsVisible(false)} />
            <AdminSugerimentsModal
                visible={adminSugerimentsVisible}
                onClose={() => setAdminSugerimentsVisible(false)}
                onRead={() => setUnreadCount(0)}
            />
        </Header>
    );
};

export default AppHeader;
